/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { Button, Typography, Box } from "@mui/material";
import { awsCronExpressionValidator } from "aws-cron-expression-validator";
import { useSnackbar } from "notistack";
import { ScheduleApi } from "../../services/ScheduleService";
import { useAxios } from "../../contexts/AxiosProvider";
import LoadingIcon from "../../reusable-component/LoadingIcon";

// Cron component for scheduling workflows
const Cron = ({ cronData, userData, openCronDialog, setOpenCronDialog }) => {
  const axios = useAxios(); // Custom Axios instance
  const [loading, setloading] = useState(false); // State for loading indicator
  const { enqueueSnackbar } = useSnackbar(); // Snackbar for notifications

  // State for cron expression values
  const [cronValue, setcronValue] = useState({
    minutes: "",
    hours: "",
    day_of_month: "",
    month: "",
    day_of_week: "",
    year: "",
  });
  const [saveOrUpdate, setsaveOrUpdate] = useState(false); // State to determine if updating or creating a cron
  const [cronError, setcronError] = useState(""); // State for cron validation error

  // Handler for updating cron expression values
  const handleCronDataChange = (event) => {
    setcronValue({
      ...cronValue,
      [event.target.name]: event.target.value,
    });
  };

  // Function to delete a scheduled workflow
  const handleDeleteScheduleWorkflow = async () => {
    try {
      const data = {
        workflow_id: cronData.workflow_id,
        workflow_type: cronData.workflow_type,
      };
      const response = await ScheduleApi.deleteScheduleProcessor(axios, data);
      if (response.status === 200) {
        enqueueSnackbar("Cron Schedulled Deleted Scuccessfully", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } catch (error) {
    } finally {
      setOpenCronDialog(false);
    }
  };

  // Function to fetch existing cron data
  const getCronData = async () => {
    const data = {
      workflow_id: cronData.workflow_id,
      workflow_type: cronData.workflow_type,
    };
    const response = await ScheduleApi.getCronData(axios, data);
    if (response.status === 200) {
      setcronValue(response.data.cron_value);
      setsaveOrUpdate(response.data.saveOrUpdate);
    }
  };

  // Fetch cron data on component mount
  useEffect(() => {
    getCronData();
  }, []);

  // Function to create a new schedule workflow
  const handleCreateScheduleWorkflow = async () => {
    const cronExpression = `${cronValue.minutes} ${cronValue.hours} ${cronValue.day_of_month} ${cronValue.month} ${cronValue.day_of_week} ${cronValue.year}`;
    try {
      for (const key in cronValue) {
        if (cronValue[key] === "") {
          throw new Error(`Value for key '${key}' is empty.`);
        }
      }
      awsCronExpressionValidator(cronExpression); // Validate cron expression
    } catch (error) {
      setcronError("Invalid Cron Expression ");
      return;
    }
    setcronError("");

    try {
      setloading(true);
      switch (cronData.workflow_type) {
        case "DATA-PROCESSOR":
          const dataProcessorData = {
            workflow_id: cronData.workflow_id,
            cron_expression: cronExpression,
            workflow_type: cronData.workflow_type,
            user_id: userData.userId,
            username: userData.username,
            cronValue: cronValue,
          };
          const dataProcessorResult = await ScheduleApi.createScheduleProcessor(
            axios,
            dataProcessorData
          );
          if (dataProcessorResult === 201) {
            enqueueSnackbar("Cron Schedulled Scuccessfully", {
              variant: "success",
              autoHideDuration: 3000,
              anchorOrigin: { vertical: "top", horizontal: "right" },
            });
          }

          break;

        case "PRE-PROCESSOR":
          const preProcessorData = {
            workflow_id: cronData.workflow_id,
            cron_expression: cronExpression,
            workflow_type: cronData.workflow_type,
            user_id: userData.userId,
            username: userData.username,
            cronValue: cronValue,
          };
          const preProcessorResult = await ScheduleApi.ScheduleDataProcessor(
            axios,
            preProcessorData
          );
          if (preProcessorResult === 201) {
            enqueueSnackbar("Cron Schedulled Scuccessfully", {
              variant: "success",
              autoHideDuration: 3000,
              anchorOrigin: { vertical: "top", horizontal: "right" },
            });
          }

          break;
        default:
          break;
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setloading(false);
      setOpenCronDialog(false);
    }
  };

  // Function to update an existing schedule workflow
  const handleUpdateScheduleWorkflow = async () => {
    const cronExpression = `${cronValue.minutes} ${cronValue.hours} ${cronValue.day_of_month} ${cronValue.month} ${cronValue.day_of_week} ${cronValue.year}`;
    try {
      for (const key in cronValue) {
        if (cronValue[key] === "") {
          throw new Error(`Value for key '${key}' is empty.`);
        }
      }
      awsCronExpressionValidator(cronExpression); // Validate cron expression
    } catch (error) {
      setcronError("Invalid Cron Expression ");
      return;
    }
    setcronError("");

    try {
      setloading(true);
      switch (cronData.workflow_type) {
        case "DATA-PROCESSOR":
          const dataProcessorData = {
            workflow_id: cronData.workflow_id,
            cron_expression: cronExpression,
            workflow_type: cronData.workflow_type,
            user_id: userData.userId,
            username: userData.username,
            cronValue: cronValue,
          };
          const dataProcessorResult = await ScheduleApi.updateScheduleProcessor(
            axios,
            dataProcessorData
          );
          if (dataProcessorResult === 201) {
            enqueueSnackbar("Cron Updated Scuccessfully", {
              variant: "success",
              autoHideDuration: 3000,
              anchorOrigin: { vertical: "top", horizontal: "right" },
            });
          }
          break;

        case "PRE-PROCESSOR":
          const preProcessorData = {
            workflow_id: cronData.workflow_id,
            cron_expression: cronExpression,
            workflow_type: cronData.workflow_type,
            user_id: userData.userId,
            username: userData.username,
            cronValue: cronValue,
          };
          const preProcessorResult = await ScheduleApi.ScheduleDataProcessor(
            axios,
            preProcessorData
          );
          if (preProcessorResult === 201) {
            enqueueSnackbar("Cron updated Scuccessfully", {
              variant: "success",
              autoHideDuration: 3000,
              anchorOrigin: { vertical: "top", horizontal: "right" },
            });
          }
          break;
        default:
          break;
      }
    } catch (error) {
      enqueueSnackbar("Something went wrong", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setloading(false);
      setOpenCronDialog(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 700,
          bgcolor: "#eee",
          color: "#000 !important",
          boxShadow: 24,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Schedule Workflow
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div style={{ fontWeight: "bold", width: "10%" }}>Cron ( </div>
          <div style={{ width: "60%", display: "flex", flexDirection: "row" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Input
                name="minutes"
                onChange={handleCronDataChange}
                value={cronValue.minutes}
              />
              <div style={{ fontSize: "10px" }}> Minutes </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 20,
              }}
            >
              <Input
                name="hours"
                onChange={handleCronDataChange}
                value={cronValue.hours}
              />
              <div style={{ fontSize: "10px" }}> Hours </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 20,
              }}
            >
              <Input
                name="day_of_month"
                onChange={handleCronDataChange}
                value={cronValue.day_of_month}
              />
              <div style={{ fontSize: "10px" }}> Day of month </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 20,
              }}
            >
              <Input
                name="month"
                onChange={handleCronDataChange}
                value={cronValue.month}
              />
              <div style={{ fontSize: "10px" }}> Month </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 20,
              }}
            >
              <Input
                name="day_of_week"
                onChange={handleCronDataChange}
                value={cronValue.day_of_week}
              />
              <div style={{ fontSize: "10px" }}> Day of the week </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: 20,
              }}
            >
              <Input
                name="year"
                onChange={handleCronDataChange}
                value={cronValue.year}
              />
              <div style={{ fontSize: "10px" }}> Year </div>
            </div>
          </div>
          <div style={{ fontWeight: "bold", width: "10%" }}> ) </div>
        </div>
        <div style={{ color: "red" }}>{cronError}</div>
        {!saveOrUpdate && (
          <Button
            size="small"
            type="submit"
            variant="contained"
            sx={{
              marginTop: "7px",
              marginRight: "7px",
              backgroundColor: "#00043C",
              "&:hover": { backgroundColor: "#00043C" },
            }}
            onClick={handleCreateScheduleWorkflow}
          >
            Add Schedule
          </Button>
        )}

        {saveOrUpdate && (
          <Button
            size="small"
            type="submit"
            variant="contained"
            sx={{
              marginTop: "7px",
              marginRight: "7px",
              backgroundColor: "#00043C",
              "&:hover": { backgroundColor: "#00043C" },
            }}
            onClick={handleUpdateScheduleWorkflow}
          >
            Update Schedule
          </Button>
        )}

        {saveOrUpdate && (
          <Button
            size="small"
            type="submit"
            variant="contained"
            sx={{
              marginTop: "7px",
              marginRight: "7px",
              backgroundColor: "#00043C",
              "&:hover": { backgroundColor: "#00043C" },
            }}
            onClick={handleDeleteScheduleWorkflow}
          >
            Delete Schedule
          </Button>
        )}
      </Box>
      {loading && <LoadingIcon />}
    </>
  );
};

export default Cron;
